import React, {useCallback} from "react";
import {useState, useEffect} from "react";

import NotificationsIcon from "@mui/icons-material/NotificationsNone";
import LockIcon from "@mui/icons-material/Lock";

// import {GetClinicDataRequestPayload} from "../../services/api/clinic/getClinic/getClinic";
// import {useGetClinic} from "../../services/api/clinic/getClinic/useGetClinic";
import {useLogout} from "../../services/api/auth/logout/useLogout";

import styles from "./Navbar.module.scss";

type NavbarUseerDataResponsePayload = {
  data: {
    account: {email: string};
  };
};

export default function Navbar() {
  const [userName, setUserName] = useState("Rano Dhillon");

  //   const getClinicData = useGetClinic();
  const logoutUser = useLogout();

  const logout = useCallback(async () => {
    await logoutUser.mutateAsync();
  }, [logoutUser]);

  //   const getClinicName = useCallback(
  //     async (payload: GetClinicDataRequestPayload) => {
  //       const response: NavbarClinicDataResponsePayload =
  //         await getClinicData.mutateAsync(payload);
  //       setClinicName(response.data.account.email);
  //     },
  //     [getClinicData]
  //   );

  //   useEffect(() => {
  //     const payload = {data: {fields: ["account.email"]}};
  //     getClinicName(payload);
  //   }, []);

  function Notifications() {
    return (
      <div className={styles.iconContainer}>
        <NotificationsIcon className={styles.icon} fontSize="medium" />
      </div>
    );
  }
  function Logout() {
    return (
      <div className={styles.iconContainer}>
        <LockIcon className={styles.icon} onClick={() => logout()} />{" "}
      </div>
    );
  }
  return (
    <div className={styles.navBarContainer}>
      <p className={styles.userName}>{userName}</p>
      <div className={styles.navOptionsContainer}>
        <Notifications />
        <Logout />
      </div>
    </div>
  );
}
